var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/duotone/ic-solar:double-alt-arrow-right-bold-duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary-shape",
    opacity: 0.5,
    d: "M6.25 19.0001C6.24989 19.1534 6.29679 19.3031 6.38439 19.429C6.47199 19.5549 6.59608 19.6509 6.73993 19.7041C6.88378 19.7573 7.04047 19.7651 7.18889 19.7265C7.33731 19.6878 7.47033 19.6046 7.57 19.4881L13.57 12.4881C13.6865 12.3521 13.7505 12.1791 13.7505 12.0001C13.7505 11.8211 13.6865 11.648 13.57 11.5121L7.57 4.51207C7.47033 4.39551 7.33731 4.31231 7.18889 4.27369C7.04047 4.23506 6.88378 4.24287 6.73993 4.29605C6.59608 4.34923 6.47199 4.44523 6.38439 4.57111C6.29679 4.69699 6.24989 4.84671 6.25 5.00007V19.0001Z",
    fill: "#007867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5119 19.5699C10.437 19.5058 10.3756 19.4276 10.331 19.3397C10.2865 19.2518 10.2596 19.156 10.2521 19.0577C10.2446 18.9595 10.2565 18.8607 10.2872 18.7671C10.3179 18.6734 10.3667 18.5867 10.4309 18.5119L16.0119 11.9999L10.4309 5.48795C10.366 5.41327 10.3165 5.3265 10.2853 5.23263C10.2541 5.13876 10.2418 5.03964 10.2491 4.94099C10.2564 4.84234 10.2831 4.7461 10.3277 4.65782C10.3723 4.56953 10.4339 4.49095 10.5091 4.42658C10.5842 4.36222 10.6713 4.31335 10.7654 4.28279C10.8594 4.25222 10.9586 4.24058 11.0572 4.24851C11.1558 4.25645 11.2519 4.28381 11.3399 4.32902C11.4278 4.37423 11.506 4.4364 11.5699 4.51195L17.5699 11.5119C17.6863 11.6479 17.7503 11.821 17.7503 11.9999C17.7503 12.1789 17.6863 12.352 17.5699 12.4879L11.5699 19.4879C11.5058 19.5628 11.4276 19.6244 11.3398 19.669C11.2519 19.7137 11.1561 19.7406 11.0579 19.7482C10.9596 19.7558 10.8608 19.744 10.7671 19.7134C10.6734 19.6828 10.5867 19.6341 10.5119 19.5699Z",
    fill: "#007867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTitle);
export default __webpack_public_path__ + "static/media/icon_title.f073f755790c6cbbf3cc9ac1b8aa2741.svg";
export { ForwardRef as ReactComponent };